export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/fr.lyaml"));
vm(require("feature-monetization/lang/fr.lyaml"));
at({ "fr": { "publicPricingPage": { "windowTitles": { "default": "Tarification | HubSpot" } } } });
};